import React, {useState, useRef, useEffect} from 'react';
import cx from 'classnames';
import './Tip.scss';

function Tip({content, header, children, className}) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogY, setDialogY] = useState(0);
  const buttonRef = useRef(null);
  const toggleDialog = (e) => {
    e.stopPropagation();
    setIsDialogOpen((old) => !old);
  };

  useEffect(() => {
    const calculateDialogY = () => {
      const offsetTop = buttonRef?.current?.offsetTop || 0;
      setDialogY(window.innerWidth < 1023 ? offsetTop : 0);
    };
    calculateDialogY();
    window.addEventListener('resize', calculateDialogY);

    return () => window.removeEventListener('resize', calculateDialogY);
  }, [buttonRef, setDialogY]);

  return (
    <div className={cx('ppq--web--tip', className)}>
      <button ref={buttonRef} onClick={toggleDialog} type='button'>
        {children}
      </button>
      <div
        data-testid='dialog'
        role='dialog'
        id='fo-mo-tip'
        aria-labelledby='fo-mo-tip-label'
        aria-describedby='fo-mo-tip-description'
        aria-modal='true'
        className={cx('ppq--web--tip--dialog', {'ppq--web--tip--dialog--open': isDialogOpen})}
        style={{top: dialogY}}
      >
        <div className='ppq--web--tip--dialog--group'>
          <h2 id='fo-mo-tip-label' className='ppq--web--tip--dialog--header'>
            {header}
          </h2>
          <div id='fo-mo-tip-description' className='ppq--web--tip--dialog--content' tabIndex={0}>
            {content}
          </div>
        </div>
        <button
          autoFocus
          aria-label='close dialog'
          data-testid='close'
          className='ppq--web--tip--dialog--close'
          onClick={toggleDialog}
          type='button'
        >
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <g id='SC075 - Cancel-Close - 32x32'>
              <path
                id='Vector Path'
                d='M12.0074 13.4429L6.95391 18.4964L5.62791 17.1704L10.6814 12.1169L5.37891 6.81442L6.68841 5.50417L11.9917 10.8067L17.2949 5.50342L18.6209 6.82942L13.3177 12.1327L18.3562 17.1712L17.0459 18.4814L12.0074 13.4429Z'
                fill='#1F3047'
              />
            </g>
          </svg>
        </button>
      </div>
    </div>
  );
}

export default Tip;
